import request from "../../../core/wrappers/axios-wrapper";
import {ApiURL} from "../../../types/constants/apiUrls/api-urls";

import {RequestType} from "../../../types/enums";

const DeleteRule = (ruleId:number) => request({
    url: ApiURL.Query.DeleteRule + "/" + ruleId,
    method: RequestType.DELETE,
});
const RuleServiceQuery = {
    DeleteRule
};

export default RuleServiceQuery;
